module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.step.options), function(option, index) {
    return (_vm.step.welcome_option === 'yes-no') ? _c('div', [(index === 0) ? _c('div', {
      staticClass: "klickbox-edit-title"
    }, [_vm._v(_vm._s(_vm.$t('edit.canvas.positive_button_text')))]) : _c('div', {
      staticClass: "klickbox-edit-title"
    }, [_vm._v(_vm._s(_vm.$t('edit.canvas.negative_button_text')))]), _vm._v(" "), _c('input', {
      staticClass: "btn",
      staticStyle: {
        "padding-top": "25px",
        "margin-top": "-20px"
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": option.label
      },
      on: {
        "change": function($event) {
          return _vm.optionUpdateText({
            event: $event,
            id: option.id
          })
        }
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.step.welcome_option === 'start') ? _c('div', [_c('div', {
    staticClass: "klickbox-edit-title"
  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.start_button_text')))]), _vm._v(" "), _c('input', {
    staticClass: "btn",
    staticStyle: {
      "padding-top": "25px",
      "margin-top": "-20px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.step.options[0].label
    },
    on: {
      "change": function($event) {
        return _vm.optionUpdateText({
          event: $event,
          id: _vm.step.options[0].id
        })
      }
    }
  })]) : _vm._e()], 2)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-7fbebe41!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/step/kind/Welcome.vue
 ** module id = 879
 ** module chunks = 1
 **/